import {branch, renderComponent} from 'recompose'

import ErrorPage from '../components/common/ErrorPage/ErrorPage'
import type {HOC} from '../types'

function withErrorPage<P>(
  getError: (props: P) => Error | string | null | undefined,
  onRetryCreator?: (props: P) => (() => unknown) | null,
): HOC<P, P> {
  return branch(
    props => !window.GLOBAL_ERROR_PAGE_DISABLED && getError(props) != null,
    renderComponent(function ErrorPageWrapper(props: P) {
      return (
        <ErrorPage
          {...props}
          error={getError(props)}
          onRetry={onRetryCreator ? onRetryCreator(props) : null}
        />
      )
    }),
  )
}
export default withErrorPage
